import crypto from 'crypto'

import { generateDBId, type ResourceKey } from 'skedyul-db/ids/generate'

/**
 * Generate a unique ID for a resource
 * @param resource - The resource key to generate the ID for
 * @returns A unique ID for the resource
 */
export const generateId = (resource: ResourceKey | undefined): string => {
  return generateDBId(resource)
}

export const generateWorkflowId = (): string => {
  return crypto.randomUUID()
}
